import { sharedRequestsTyped } from "@/api/(requests)/sharedTyped";

export async function sendWelcomeEmail({ patientId }: { patientId: string }): Promise<void> {
  return sharedRequestsTyped.send_on_demand_welcome_email({
    context: { showLoader: false },
    urlParams: { patientId },
  });
}
